import React, { useState } from "react"
import { Grid } from "@material-ui/core"

import AgreementCard from "./AgreementCard"
import AgreementModal from "./AgreementModal"
import { getLocale } from "locale.js"

import { makeStyles } from "@material-ui/core/styles"
import { backgroundFixed } from "utils/backgroundFixed.js"

const useStyle = makeStyles(theme => ({
  container: {
    paddingTop: "26px",
  },
}))

const AgreementCardList = props => {
  const classes = useStyle()
  const { toses } = props
  const [open, setOpen] = useState(false)
  const [card, setCard] = useState({})

  const handleClose = () => {
    setOpen(false)
    backgroundFixed(false)
  }

  const isEmpty = val => {
    return !val ? (val === 0 || val === false ? false : true) : false
  }

  const getLocaleContents = tos => {
    const locale = getLocale()
    const localeNameArray = {
      ja: "name",
      en: "nameEn",
    }
    const localeDetailArray = {
      ja: "detail",
      en: "detailEn",
    }
    // 返却値にデフォルトを設定（日本語は必須の想定なので日本語を設定）
    const defaultResponse = {
      name: tos.name || "",
      detail: tos.detail || "",
    }
    // チェックの優先順は、現在のlocale > 言語の優先順（localeArrayの中身) とした
    // 現在のlocaleのチェック
    // 各言語のnameとdetailが設定されているかいないかで判断する。
    if (
      !isEmpty(tos[localeNameArray[locale]]) &&
      !isEmpty(tos[localeDetailArray[locale]])
    ) {
      return {
        name: tos[localeNameArray[locale]],
        detail: tos[localeDetailArray[locale]],
      }
    }

    // 今後、対応言語が追加された際はその優先順で配列に追加すること。
    const localeArray = ["ja", "en"]
    // 現在のlocaleに文言が登録されていない場合、defalt(ja)をチェック
    // 今後、対応言語が追加された際は配列に優先順に追加すること。
    for (const key of localeArray) {
      // 各言語のnameとdetailが設定されているかいないかで判断する。
      if (
        !isEmpty(tos[localeNameArray[key]]) &&
        !isEmpty(tos[localeDetailArray[key]])
      ) {
        // 各言語のタイトルが存在すれば、その言語の詳細をチェック
        return {
          name: tos[localeNameArray[key]],
          detail: tos[localeDetailArray[key]],
        }
      }
    }
    // どの言語にも設定されていない場合はデフォルトを返却
    return defaultResponse
  }

  const getContentsName = tos => {
    let result = getLocaleContents(tos)
    return result.name
  }

  const getContentsDetail = tos => {
    let result = getLocaleContents(tos)
    return result.detail
  }

  const setAgreementModal = tos => {
    return {
      name: getContentsName(tos),
      detail: getContentsDetail(tos),
    }
  }

  return (
    <>
      <Grid
        container
        className={classes.container}
        direction="row"
        alignItems="center"
        spacing={2}
      >
        {toses.map((tos, index) => (
          <Grid
            item
            key={`card${index}`}
            className="agreementcard"
            xs={12}
            sm={6}
            lg={6}
          >
            <AgreementCard
              name={getContentsName(tos)}
              detail={getContentsDetail(tos)}
              index={index}
              onClick={() => {
                setOpen(true)
                setCard(setAgreementModal(tos))
              }}
            />
          </Grid>
        ))}
      </Grid>
      <AgreementModal open={open} onClose={handleClose} card={card} />
    </>
  )
}

export default AgreementCardList
